import { render } from "./WegowAds.vue?vue&type=template&id=c1a31da2"
import script from "./WegowAds.vue?vue&type=script&lang=js"
export * from "./WegowAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__